export default function Footer() {
  const year = 2026;

  const cols = [
    {
      title: 'Product',
      links: [
        { label: 'Wallet', href: '/#features' },
        { label: 'WebOns', href: '/#webons' },
        { label: 'Nomo-ID Protocol', href: '/#features' },
        { label: 'Messenger', href: '/#community' },
        { label: 'Community Governance', href: '/#community' },
      ],
    },
    {
      title: 'Developers',
      links: [
        { label: 'WebOn SDK', href: '/#build' },
        { label: 'Nomo-WebOn-Kit', href: '/#build' },
        { label: 'Nomo-UI-Kit', href: '/#build' },
        { label: 'WalletKit-Dart', href: '/#build' },
        { label: 'GitHub', href: 'https://github.com' },
        { label: 'Documentation', href: '/#build' },
      ],
    },
    {
      title: 'Company',
      links: [
        { label: 'About NOMO', href: '/#welcome' },
        { label: 'For Investors', href: '/investors' },
        { label: 'Community', href: '/#community' },
        { label: 'FAQ', href: '/#faq' },
        { label: 'Privacy Policy', href: '/privacypolicy' },
        { label: 'Terms of Service', href: '#' },
      ],
    },
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__inner">
          <div>
            <div className="footer__brand-logo">NOMO</div>
            <p className="footer__brand-desc">
              The Premium Gateway to the Decentralized World. Web3.
              Identity. Community. Unified.
            </p>
            <p className="footer__brand-desc" style={{ marginTop: '0.75rem' }}>
              Contact us at{' '}
              <a
                href="mailto:support@nomo.app"
                className="footer__link"
                style={{ color: 'var(--gold)' }}
              >
                support@nomo.app
              </a>
            </p>
          </div>

          {cols.map((col) => (
            <div key={col.title}>
              <div className="footer__col-title">{col.title}</div>
              <ul className="footer__links" role="list">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="footer__link">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="footer__bottom">
          <div className="footer__copyright">
            © {year} NOMO Digital FlexCo · All rights reserved
          </div>
          <div className="footer__legal">
            <a href="/privacypolicy" className="footer__legal-link">Privacy</a>
            <a href="#" className="footer__legal-link">Terms</a>
            <a href="#" className="footer__legal-link">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
